/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Powered_ByInputs */



/**
* | output |
* | --- |
* | "Powered by Closed Caption Converter \| www.closedcaptionconverter.com" |
*
* @param {Plain_Text_Import_Powered_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_powered_by = /** @type {((inputs?: Plain_Text_Import_Powered_ByInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Powered_ByInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Propulse par Closed Caption Converter | www.closedcaptionconverter.com")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereitgestellt von Closed Caption Converter | www.closedcaptionconverter.com")
	if (locale === "it") return /** @type {LocalizedString} */ ("Realizzato da Closed Caption Converter | www.closedcaptionconverter.com")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создано с помощью программы для конвертации субтитров | www.closedcaptionconverter.com")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desarrollado por Closed Caption Converter | www.closedcaptionconverter.com")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("由 Closed Caption Converter 提供技术支持 | www.closedcaptionconverter.com")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クローズドキャプションコンバーター搭載 | www.closedcaptionconverter.com")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लोज्ड कैप्शन कन्वर्टर द्वारा संचालित | www.closedcaptionconverter.com")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Com tecnologia Closed Caption Converter | www.closedcaptionconverter.com")
	return /** @type {LocalizedString} */ ("Powered by Closed Caption Converter | www.closedcaptionconverter.com")
});